import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation } from '../types/ApprovalOperation';
import { MAX_APPROVAL_NOTE_LENGTH, MAX_APPROVAL_TITLE_LENGTH } from '../constants/requestModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const maxNumberOfApprovers = 10;
export const getPrimaryButtonDisabledState = ({
  approvalOperation,
  noteContent,
  isNoteTooLong,
  approversCount,
  isDueDateValid,
  canEditApprovalTitle,
  approvalTitle,
  isApprovalTitleTooLong
}) => {
  const noteIsTooLong = {
    isDisabled: true,
    disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.modal.disabledTooltip.noteTooLong",
      options: {
        maxLength: MAX_APPROVAL_NOTE_LENGTH
      }
    })
  };
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      {
        if (!isDueDateValid) {
          return {
            isDisabled: true,
            disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.modal.disabledTooltip.invalidDueDate"
            })
          };
        }
        if (canEditApprovalTitle && isApprovalTitleTooLong) {
          if (!approvalTitle.trim()) {
            return {
              isDisabled: true,
              disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "productApprovals.modal.disabledTooltip.approvalTitleRequired"
              })
            };
          }
          return {
            isDisabled: true,
            disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.modal.disabledTooltip.approvalTitleTooLong",
              options: {
                maxLength: MAX_APPROVAL_TITLE_LENGTH
              }
            })
          };
        }
        if (!approversCount) {
          return {
            isDisabled: true,
            disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.modal.disabledTooltip.noApprovers"
            })
          };
        }
        if (approversCount > maxNumberOfApprovers) {
          return {
            isDisabled: true,
            disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.modal.disabledTooltip.tooManyApprovers",
              options: {
                maxNumberOfApprovers
              }
            })
          };
        }
        if (isNoteTooLong) {
          return noteIsTooLong;
        }
        return {
          isDisabled: false,
          disabledTooltip: undefined
        };
      }
    case ApprovalOperation.CANCEL:
    case ApprovalOperation.REJECT:
      if (!noteContent) {
        return {
          isDisabled: true,
          disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.modal.disabledTooltip.noteRequired"
          })
        };
      }
      if (isNoteTooLong) {
        return noteIsTooLong;
      }
      return {
        isDisabled: false,
        disabledTooltip: undefined
      };
    case ApprovalOperation.APPROVE:
    default:
      if (isNoteTooLong) {
        return noteIsTooLong;
      }
      return {
        isDisabled: false,
        disabledTooltip: undefined
      };
  }
};